export default __webpack_public_path__ + "static/media/selfPortraitLateWorks.42d71955.jpg";